<template>
	<UserRegistrationFullScreenLayout class="temporary-verification-code">
		<div class="page-title">Verification Code</div>
		<div class="page-description">Generate and copy this code and go back to the verification page.</div>
		<div class="verification-code-box">{{ verificationCode }}</div>
		<v-btn color="primary" @click="generateOrCopyVerificationCode()" outlined :loading="showLoader">{{ buttonText }}</v-btn>
	</UserRegistrationFullScreenLayout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import UserRegistrationFullScreenLayout from './UserRegistrationFullScreenLayout.vue';
import UserRegistrationMixin from './helpers/UserRegistrationMixin';
const GENERATE_CODE_TEXT = 'Generate Code';
export default {
	name: 'TemporaryVerificationCode',
	components: {
		UserRegistrationFullScreenLayout,
	},
	mixins: [UserRegistrationMixin],
	computed: {
		...mapGetters(['user']),
	},
	methods: {
		...mapActions(['getOneTimeToken']),
		async getNewVerificationCode() {
			const res = await this.getOneTimeToken();
			if (!res) {
				console.log('failed to get user token');
				return;
			}
			this.verificationCode = res.token || '';
		},
		async generateOrCopyVerificationCode() {
			if (this.buttonText === GENERATE_CODE_TEXT) {
				await this.getNewVerificationCode();
				this.buttonText = 'Copy';
				return;
			}
			this.showLoader = true;
			navigator.clipboard.writeText(this.verificationCode);
			setTimeout(() => {
				this.buttonText = 'Copied!';
				this.showLoader = false;
				setTimeout(() => {
					this.buttonText = 'Copy';
				}, 2000);
			}, 700);
		},
	},
	data: () => ({
		verificationCode: '------',
		buttonText: GENERATE_CODE_TEXT,
		showLoader: false,
	}),
};
</script>

<style scoped lang="scss">
.temporary-verification-code {
	.verification-code-box {
		margin: 40px 0 0 0;
		padding: 15px 20px 15px 35px;
		letter-spacing: 20px;
		border-radius: 12px;
		box-shadow: 0 3px 10px 4px rgb(0 0 0 / 15%);
		color: #5c8df5;
	}
}
</style>
